import { COLORS } from '../../constants/theme';

interface CollapsibleSectionProps {
  title: string;
  accent?: string;
  collapsed: boolean;
  onToggle: () => void;
  rightContent?: React.ReactNode;
  children?: React.ReactNode;
}

export function CollapsibleSection({
  title, accent, collapsed, onToggle, rightContent, children,
}: CollapsibleSectionProps) {
  return (
    <>
      <div
        onClick={onToggle}
        style={{
          background: COLORS.sectionHeader,
          borderBottom: `1px solid ${COLORS.border}`,
          borderLeft: accent ? `3px solid ${accent}` : undefined,
          padding: '8px 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              color: COLORS.text.muted,
              fontSize: 10,
              display: 'inline-block',
              transform: collapsed ? 'rotate(-90deg)' : 'rotate(0)',
              transition: 'transform 0.15s',
            }}
          >
            &#x25BC;
          </span>
          <span
            style={{
              color: COLORS.text.secondary,
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            {title}
          </span>
        </div>
        {rightContent && (
          <span style={{ color: COLORS.text.tertiary, fontSize: 12 }}>
            {rightContent}
          </span>
        )}
      </div>
      {!collapsed && children}
    </>
  );
}
